<div class="bg-white py-3 px-7 2xl:container 2xl:mx-auto">
  <nav class="flex justify-between items-center px-4">
    <div class="flex items-center">
      <a href="#">
        <picture>
          <img src="assets/img/pulse-color.png" alt="" width="120" />
        </picture>
      </a>
      {{ applicationName }}
    </div>
    <div *ngIf="showSearchPanel">
      <pulse-search (searchEvent)='search($event)' class="w-300"></pulse-search>
    </div>

    <div class="flex space-x-5 justify-center items-center pl-2">
      <div
        *ngIf="showUserPlan && userInfo"
        class="min-w-24 p-2 bg-primary-500 text-white rounded-lg text-xs"
      >
        {{ getPlan() }} plan
      </div>
      <div class="text-sm font-light">
        Welcome back, <br />
        <span class="text-base font-medium">{{ userInfo?.fullName }}!</span>
      </div>

      <pulse-user [showMyAccount]='showMyAccount'(closeSessionEvent)="closeSession()"></pulse-user>
    </div>
  </nav>
</div>
